import { SecureLayoutComponent } from './secure-layout/secure-layout.component';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';

export { SecureLayoutComponent, AuthLayoutComponent };
